import { typeCreatorV2 } from 'redux/utils/common';

// //  [REDUCER][TYPE]
export const SET_TOPIC_DETAIL: string = typeCreatorV2(
  'TopicShowDetailReducer',
  'SetTopicDetail'
);
export const SET_TOPIC_LIST: string = typeCreatorV2(
  'TopicShowDetailReducer',
  'SetTopicList'
);

export const SUBSCRIBE_TO_NEWS_LETTER: string = typeCreatorV2(
  'TopicShowDetailReducer',
  'SubscribeToNewsLetter'
);

export const SET_TOPIC_LIST_BY_CATEGORY: string = typeCreatorV2(
  'TopicShowDetailReducer',
  'SetTopicListByCategory'
);
